import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import {
  GroupContributionByGeneralMeeting,
  GroupContributionByGeneralMeetingForm,
} from "./groupContributionByGeneralMeetingDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<GroupContributionByGeneralMeeting>,
  data?: GroupContributionByGeneralMeeting,
) {
  return new GroupContributionByGeneralMeetingForm(dispatch, context, data);
}

export function applyForm(
  form: GroupContributionByGeneralMeetingForm,
): GroupContributionByGeneralMeeting {
  return {
    type: DecisionType.groupContributionByGeneralMeeting,
    resolutionBy: "generalMeeting",
    usePowerOfAttorney: form.usePowerOfAttorney.value,
    groupContributionCompanies: form.companies.slice(),
  };
}

export function validate(form: GroupContributionByGeneralMeetingForm) {
  return form.validate();
}

export function isValid(form: GroupContributionByGeneralMeetingForm) {
  return form.isValid;
}

export function handleEvent(form: GroupContributionByGeneralMeetingForm, event: DbotEvent) {
  form.handleEvent(event);
}

export const groupContributionByGeneralMeetingHandler: DecisionTypeHandler<
  DecisionType.groupContributionByGeneralMeeting,
  GroupContributionByGeneralMeeting,
  GroupContributionByGeneralMeetingForm
> = {
  type: DecisionType.groupContributionByGeneralMeeting,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent,
};
